module.exports = __webpack_public_path__ + "media/images/share-icon-a1974beaca781581f7d5e64eb700759b.png";